// extracted by mini-css-extract-plugin
module.exports = {"columnRecord":"ColumnRecord_columnRecord__3gH4V","content":"ColumnRecord_content__2AEnT","shadow":"ColumnRecord_shadow__bqPVe"};